import React from "react";
import { Box, Typography } from "@mui/material";

// Standardized page header: brand-colored title, muted description, and an
// optional right-aligned action area (buttons). Owns the spacing so every page
// header looks and breathes the same. `children` render under the description
// (e.g. a dashboard link).
const PageHeader = ({ title, description, action, children }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { xs: "stretch", sm: "flex-start" },
      justifyContent: "space-between",
      gap: 2,
      mb: 4,
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="h3"
        sx={{ color: "primary.main", mb: description ? 1 : 0 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography color="text.secondary">{description}</Typography>
      )}
      {children && <Box sx={{ mt: 1 }}>{children}</Box>}
    </Box>
    {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
  </Box>
);

export default PageHeader;
